<template>
    <div id="mergeClaimModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mergeClaimTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="mergeClaimTitle">Merge Claim</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div class="row mb-3 mx-3 p-3 border">
                        <div class="col-auto h5 font-weight-bold mr-0 pr-0">
                            <i class="fas fa-exclamation-triangle text-warning"></i>WARNING:
                        </div>
                        <div class="col warning-text">
                            Merging patient claim information cannot be undone. Select a patient claim to merge into and press the merge button
                            to proceed.
                        </div>
                    </div>
                    <div class="font-weight-bold">Merge</div>
                    <div class="row ml-1">                        
                        <div v-if="claim" class="col-sm-4">{{ claim.patient_last }}, {{ claim.patient_first }}</div>              
                        <div v-if="claim" class="col-sm-8">
                            <div class="row">
                                <div class="col-sm-6 line-height-1"><small>DOB: {{ claim.patient_dob }}</small></div>                                
                                <div class="line-height-1"><small>Injury Date: {{ claim.injury_date }}</small></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 line-height-1"><small>Claim Number: {{ claim.claim_number }}</small></div>
                                <div class="line-height-1"><small>Payer: {{ claim.payer_name }}</small></div>                                  
                            </div>
                            <div class="row">
                                <div class="col-sm-6 line-height-1"><small>Provider: {{ claim.rendering_provider_name }}</small></div>
                                <div class="line-height-1"><small>Document Count: {{ claim.document_count }}</small></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 line-height-1"><small>Created: {{ claim.created_at }}</small></div>
                            </div>                    
                        </div>
                    </div>
                    <div class="mt-2"><span class="font-weight-bold">Into</span> <small><em>(Select a claim to merge into.)</em></small></div>
                    <div class="list-group list-group-scroll">
                        <template v-for="c in duplicates">
                            <button type="button" :class="['list-group-item list-group-item-action', { 'active': selectedId == c.id }]" :key="c.id" @click="select(c.id)" :disabled="mergeInProgress">
                                <div class="row">
                                    <div class="col-sm-4">{{ c.patient_last }}, {{ c.patient_first }}</div>
                                    <div class="col-sm-8">
                                        <div class="row">
                                            <div class="col-sm-6 line-height-1"><small>DOB: {{ c.patient_dob }}</small></div>                                
                                            <div class="line-height-1"><small>Injury Date: {{ c.injury_date }}</small></div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 line-height-1"><small>Claim Number: {{ c.claim_number }}</small></div>
                                            <div class="line-height-1"><small>Payer: {{ c.payer_name }}</small></div>                                  
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 line-height-1"><small>Provider: {{ c.rendering_provider_name }}</small></div>
                                            <div class="line-height-1"><small>Document Count: {{ c.document_count }}</small></div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 line-height-1"><small>Created: {{ c.created_at }}</small></div>
                                        </div>                                        
                                    </div>
                                </div>                     
                            </button>
                        </template>
                    </div>                                       
                </div>
                <div :class="['modal-footer', { 'justify-content-center' :mergeInProgress }]">
                    <div v-if="mergeInProgress" class="h5 text-muted">
                        <i class="fa fa-spinner fa-spin"></i> Merge in progress. Please wait...
                    </div>
                    <div v-else>
                        <button class="btn btn-danger" @click="merge()" :disabled="!selectedId">Merge</button>
                        <button class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    </div>              
                </div>                
            </div>                  
        </div>
    </div>
</template>

<script>
export default {
    data() {
         return {
             claim: null,
             duplicates: [],
             selectedId: null,
             mergeInProgress: false
         }
    },
    methods: {
        show: function (id) {
            this.claim = null;
            this.duplicates = [];
            this.selectedId = null;
            this.mergeInProgress = false;
            axios.get('/ajax/admin/claims/' + id + '/duplicates')
                .then(response => {
                    this.claim = response.data.claim;
                    this.duplicates = response.data.duplicates;
                    $('#mergeClaimModal').modal('show');
                })
                .catch(error => {
                    let message = error.response ? error.response.data.message : 'Unable to apply payment. Please contact Worx support.';
                    toastr['error'](message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
        },
        select: function (id) {
            this.selectedId = id;
        },
        merge: function () {
            this.mergeInProgress = true;
            axios.post('/ajax/admin/claims/merge', {
                sourceId: this.claim.id,
                destinationId: this.selectedId
            }).then(response => {
                this.mergeInProgress = false;
                let message = (response && response.data.message) ? response.data.message : 'The claims were successfully merged.';
                toastr['success'](message, 'Success', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });                
               $('#mergeClaimModal').modal('hide');
            }).catch(error => {
                this.mergeInProgress = false;
                let message = error.response ? error.response.data.message : 'Unable to apply payment. Please contact Worx support.';
                toastr['error'](message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                $('#mergeClaimModal').modal('hide');
            });
        }
    },
    created() {
        eventHub.$on('show-merge-claim', this.show);        
    },
    beforeDestroy() {
        eventHub.$off('show-merge-claim');
    }      
}
</script>

<style scoped>
    .fa-exclamation-triangle.text-warning {
        background:linear-gradient(#000,#000) center bottom/20% 84% no-repeat;
    }

    .warning-text {
        font-weight: bold;
        position: relative;        
        top: 5px;
        line-height: 1.25em;
    }

    .line-height-1 {
        line-height: 1;
    }

    .list-group-scroll {
        max-height: 500px; 
        overflow: scroll; 
        -webkit-overflow-scrolling: touch;
    }    
</style>